import { handleJsonResponse, requestGet, SERVICE_URL } from 'util/request';

import { StateType } from './types';

export const fetchStateGeometry = async (stateId: string, countryId: string): Promise<StateType> =>
  handleJsonResponse(
    await requestGet(`${SERVICE_URL}/state_geometry_v2/?state=${stateId}&country=${countryId}`),
  );

export default fetchStateGeometry;
